export function walkOrganizations(orgId, organizations) {
    const visited = new Set();
    walkOrganizationsRecursive(orgId, visited, organizations);
    return Array.from(visited.values());
}
function walkOrganizationsRecursive(orgId, visited, organizations) {
    visited.add(orgId);
    for (const organization of organizations[orgId].adjacencyList) {
        if (!visited.has(organization)) {
            walkOrganizationsRecursive(organization, visited, organizations);
        }
    }
}
